import React from "react";
import { inject, observer } from "mobx-react";
import { Checkbox, FormRow, PopupHint } from "@op/opds.opux";
import { useMessageGetter } from "react-message-context";

const ContactCustomer = observer(({ FeedbackStore }) => {
  const key = "contactCustomer";
  const { feedback, updateValue, updateIncluded } = FeedbackStore;
  const msgs = useMessageGetter("feedback.form");

  updateIncluded(key, true);

  return (
    <FormRow
      label={`${msgs("contactCustomer.form.label")} ${msgs("optional")}`}
      labelId={`${msgs("contactCustomer.form.label")} ${msgs("optional")}`}
      htmlFor={`CFF-${key}`}
      hint={
        <PopupHint iconProps={{ "aria-label": msgs("contactCustomer.hint") }}>
          {msgs("contactCustomer.hint")}
        </PopupHint>
      }
    >
      <Checkbox
        id={`CFF-${key}`}
        checked={feedback.contactCustomer.value}
        onChange={(_e, val) => updateValue(key, val)}
      >
        <div className="cff-checkbox">{msgs("contactCustomer.label")}</div>
      </Checkbox>
    </FormRow>
  );
});

export default inject("FeedbackStore")(ContactCustomer);
